import {appRoute} from '../../../../../app-route';
import {DomainNameEnum} from '../../../../../provider/domain-config/domain-config-type';
import {LangKeyType, LocalePluralLangKeyType} from '../../../../../provider/locale/translation/type';
import {AnalyticsTarget} from '../../../../../service/analytics/analytics';
import {CclStatusEnum} from '../../../../../service/ccl-statistic/ccl-statistic-type';
import {DashboardRecommendationTypeEnum} from '../../../../../service/dashboard/dashboard-recommendations/dashboard-recommendations-type';
import {ProvidersIdsEnum} from '../../../../../util/type';
import {objectToUrlParameters} from '../../../../../util/url';
import {SourcesSearchParametersEnum} from '../../../sources/sources-type';

type CommonRecommendationKeysType = Exclude<
    DashboardRecommendationTypeEnum,
    DashboardRecommendationTypeEnum.yandexPosts | DashboardRecommendationTypeEnum.googlePosts
>;

export const recommendationTitles: Record<CommonRecommendationKeysType, LangKeyType> = {
    [DashboardRecommendationTypeEnum.check]: 'DASHBOARD_PAGE__RECOMMENDATION__CHECK_TITLE',
    [DashboardRecommendationTypeEnum.review]: 'DASHBOARD_PAGE__RECOMMENDATION__REVIEW_TITLE',
    [DashboardRecommendationTypeEnum.gallery]: 'DASHBOARD_PAGE__RECOMMENDATION__GALLERY_TITLE',
    [DashboardRecommendationTypeEnum.description]: 'DASHBOARD_PAGE__RECOMMENDATION__DESCRIPTION_TITLE',
    [DashboardRecommendationTypeEnum.category]: 'DASHBOARD_PAGE__RECOMMENDATION__CATEGORY_TITLE',
    [DashboardRecommendationTypeEnum.needAction]: 'DASHBOARD_PAGE__RECOMMENDATION__NEED_ACTION_TITLE',
    [DashboardRecommendationTypeEnum.socialLinks]: 'DASHBOARD_PAGE__RECOMMENDATION__SOCIAL_MEDIA_LINKS_TITLE',
    [DashboardRecommendationTypeEnum.messengers]: 'DASHBOARD_PAGE__RECOMMENDATION__MESSENGER_TITLE',
    [DashboardRecommendationTypeEnum.peculiarities]: 'DASHBOARD_PAGE__RECOMMENDATION__PECULIARITIES__TITLE',
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]:
        'DASHBOARD_PAGE__RECOMMENDATION__GENERATE_REVIEWS__TITLE',
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_GOOD_PLACE__TITLE',

    [DashboardRecommendationTypeEnum.yandexNavigationStories]:
        'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_NAVIGATION_STORIES__TITLE',
    [DashboardRecommendationTypeEnum.yandexStories]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_STORIES__TITLE',
    [DashboardRecommendationTypeEnum.logo]: 'DASHBOARD_PAGE__RECOMMENDATION__LOGO__TITLE',
    [DashboardRecommendationTypeEnum.cover]: 'DASHBOARD_PAGE__RECOMMENDATION__COVER__TITLE',
    [DashboardRecommendationTypeEnum.products]: 'DASHBOARD_PAGE__RECOMMENDATION__PRODUCTS__TITLE',
};

export const recommendationSubtitles: Record<CommonRecommendationKeysType, LangKeyType> = {
    [DashboardRecommendationTypeEnum.check]: 'DASHBOARD_PAGE__RECOMMENDATION__CHECK_SUBTITLE',
    [DashboardRecommendationTypeEnum.review]: 'DASHBOARD_PAGE__RECOMMENDATION__REVIEW_SUBTITLE',
    [DashboardRecommendationTypeEnum.gallery]: 'DASHBOARD_PAGE__RECOMMENDATION__GALLERY_SUBTITLE',
    [DashboardRecommendationTypeEnum.description]: 'DASHBOARD_PAGE__RECOMMENDATION__DESCRIPTION_SUBTITLE',
    [DashboardRecommendationTypeEnum.category]: 'DASHBOARD_PAGE__RECOMMENDATION__CATEGORY_SUBTITLE',
    [DashboardRecommendationTypeEnum.needAction]: 'DASHBOARD_PAGE__RECOMMENDATION__NEED_ACTION_SUBTITLE',
    [DashboardRecommendationTypeEnum.socialLinks]: 'DASHBOARD_PAGE__RECOMMENDATION__SOCIAL_MEDIA_LINKS_SUBTITLE',
    [DashboardRecommendationTypeEnum.messengers]: 'DASHBOARD_PAGE__RECOMMENDATION__MESSENGER_SUBTITLE',
    [DashboardRecommendationTypeEnum.peculiarities]: 'DASHBOARD_PAGE__RECOMMENDATION__PECULIARITIES__SUBTITLE',
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]:
        'DASHBOARD_PAGE__RECOMMENDATION__GENERATE_REVIEWS__SUBTITLE',
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_GOOD_PLACE__SUBTITLE',

    [DashboardRecommendationTypeEnum.yandexNavigationStories]:
        'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_NAVIGATION_STORIES__SUBTITLE',
    [DashboardRecommendationTypeEnum.yandexStories]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_STORIES__SUBTITLE',
    [DashboardRecommendationTypeEnum.logo]: 'DASHBOARD_PAGE__RECOMMENDATION__LOGO__SUBTITLE',
    [DashboardRecommendationTypeEnum.cover]: 'DASHBOARD_PAGE__RECOMMENDATION__COVER__SUBTITLE',
    [DashboardRecommendationTypeEnum.products]: 'DASHBOARD_PAGE__RECOMMENDATION__PRODUCTS__SUBTITLE',
};

const recommendationDetails: Record<CommonRecommendationKeysType, LangKeyType> = {
    [DashboardRecommendationTypeEnum.check]: 'DASHBOARD_PAGE__RECOMMENDATION__CHECK_DETAILS',
    [DashboardRecommendationTypeEnum.review]: 'DASHBOARD_PAGE__RECOMMENDATION__REVIEW_DETAILS',
    [DashboardRecommendationTypeEnum.gallery]: 'DASHBOARD_PAGE__RECOMMENDATION__GALLERY_DETAILS',
    [DashboardRecommendationTypeEnum.description]: 'DASHBOARD_PAGE__RECOMMENDATION__DESCRIPTION_DETAILS',
    [DashboardRecommendationTypeEnum.category]: 'DASHBOARD_PAGE__RECOMMENDATION__CATEGORY_DETAILS',
    [DashboardRecommendationTypeEnum.needAction]: 'DASHBOARD_PAGE__RECOMMENDATION__NEED_ACTION_DETAILS',
    [DashboardRecommendationTypeEnum.socialLinks]: 'DASHBOARD_PAGE__RECOMMENDATION__SOCIAL_MEDIA_LINKS_DETAILS',
    [DashboardRecommendationTypeEnum.messengers]: 'DASHBOARD_PAGE__RECOMMENDATION__MESSENGER_DETAILS',
    [DashboardRecommendationTypeEnum.peculiarities]: 'DASHBOARD_PAGE__RECOMMENDATION__PECULIARITIES__DETAILS',
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]:
        'DASHBOARD_PAGE__RECOMMENDATION__GENERATE_REVIEWS__DETAILS',
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_GOOD_PLACE__DETAILS',

    [DashboardRecommendationTypeEnum.yandexNavigationStories]:
        'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_NAVIGATION_STORIES__DETAILS',
    [DashboardRecommendationTypeEnum.yandexStories]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_STORIES__DETAILS',
    [DashboardRecommendationTypeEnum.logo]: 'DASHBOARD_PAGE__RECOMMENDATION__LOGO__DETAILS',
    [DashboardRecommendationTypeEnum.cover]: 'DASHBOARD_PAGE__RECOMMENDATION__COVER__DETAILS',
    [DashboardRecommendationTypeEnum.products]: 'DASHBOARD_PAGE__RECOMMENDATION__PRODUCTS__DETAILS',
};

export function getRecommendationDetailsLangKey(
    recommendation: CommonRecommendationKeysType,
    domainName: string
): LangKeyType {
    if (
        domainName === DomainNameEnum.brandWizard &&
        recommendation === DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount
    ) {
        return 'DASHBOARD_PAGE__RECOMMENDATION__GENERATE_REVIEWS__DETAILS__BRANDWIZARD';
    }

    return recommendationDetails[recommendation];
}

const companiesLocalePluralLangKeys: LocalePluralLangKeyType = {
    singular: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_COMPANY__SINGULAR',
    few: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_COMPANY__FEW',
    many: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_COMPANY__MANY',
};

export const recommendationTagCounterName: Record<DashboardRecommendationTypeEnum, LocalePluralLangKeyType> = {
    [DashboardRecommendationTypeEnum.check]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.review]: {
        singular: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_REVIEW__SINGULAR',
        few: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_REVIEW__FEW',
        many: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_REVIEW__MANY',
    },
    [DashboardRecommendationTypeEnum.gallery]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.description]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.category]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.needAction]: {
        singular: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_SOURCE__SINGULAR',
        few: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_SOURCE__FEW',
        many: 'DASHBOARD_PAGE__RECOMMENDATION__TAG_SOURCE__MANY',
    },

    [DashboardRecommendationTypeEnum.socialLinks]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.messengers]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.peculiarities]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: companiesLocalePluralLangKeys,

    [DashboardRecommendationTypeEnum.yandexNavigationStories]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.yandexStories]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.logo]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.cover]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.products]: companiesLocalePluralLangKeys,

    [DashboardRecommendationTypeEnum.googlePosts]: companiesLocalePluralLangKeys,
    [DashboardRecommendationTypeEnum.yandexPosts]: companiesLocalePluralLangKeys,
};

export const recommendationLinkText: Record<DashboardRecommendationTypeEnum, LangKeyType> = {
    [DashboardRecommendationTypeEnum.check]: 'DASHBOARD_PAGE__RECOMMENDATION__CHECK_LINK_TEXT',
    [DashboardRecommendationTypeEnum.review]: 'DASHBOARD_PAGE__RECOMMENDATION__REVIEW_LINK_TEXT',
    [DashboardRecommendationTypeEnum.gallery]: 'DASHBOARD_PAGE__RECOMMENDATION__GALLERY_LINK_TEXT',
    [DashboardRecommendationTypeEnum.description]: 'DASHBOARD_PAGE__RECOMMENDATION__DESCRIPTION_LINK_TEXT',
    [DashboardRecommendationTypeEnum.category]: 'DASHBOARD_PAGE__RECOMMENDATION__CATEGORY_LINK_TEXT',
    [DashboardRecommendationTypeEnum.needAction]: 'DASHBOARD_PAGE__RECOMMENDATION__NEED_ACTION_LINK_TEXT',
    [DashboardRecommendationTypeEnum.socialLinks]: 'DASHBOARD_PAGE__RECOMMENDATION__SOCIAL_MEDIA_LINKS_LINK_TEXT',
    [DashboardRecommendationTypeEnum.messengers]: 'DASHBOARD_PAGE__RECOMMENDATION__MESSENGER_LINK_TEXT',
    [DashboardRecommendationTypeEnum.peculiarities]: 'DASHBOARD_PAGE__RECOMMENDATION__PECULIARITIES__LINK_TEXT',
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]:
        'DASHBOARD_PAGE__RECOMMENDATION__GENERATE_REVIEWS__LINK_TEXT',
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_GOOD_PLACE__LINK_TEXT',

    [DashboardRecommendationTypeEnum.yandexNavigationStories]:
        'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_NAVIGATION_STORIES__LINK_TEXT',
    [DashboardRecommendationTypeEnum.yandexStories]: 'DASHBOARD_PAGE__RECOMMENDATION__YANDEX_STORIES__LINK_TEXT',
    [DashboardRecommendationTypeEnum.logo]: 'DASHBOARD_PAGE__RECOMMENDATION__LOGO__LINK_TEXT',
    [DashboardRecommendationTypeEnum.cover]: 'DASHBOARD_PAGE__RECOMMENDATION__COVER__LINK_TEXT',
    [DashboardRecommendationTypeEnum.products]: 'DASHBOARD_PAGE__RECOMMENDATION__PRODUCTS__LINK_TEXT',

    [DashboardRecommendationTypeEnum.yandexPosts]: 'DASHBOARD_PAGE__RECOMMENDATION__POSTS__LINK_TEXT',
    [DashboardRecommendationTypeEnum.googlePosts]: 'DASHBOARD_PAGE__RECOMMENDATION__POSTS__LINK_TEXT',
};

export const recommendationLinkUrl: Record<DashboardRecommendationTypeEnum, string> = {
    [DashboardRecommendationTypeEnum.check]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.review]: appRoute.reviewsManagementReviews.path,
    [DashboardRecommendationTypeEnum.gallery]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.description]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.category]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.needAction]: `${appRoute.sources.path}?${objectToUrlParameters({
        [SourcesSearchParametersEnum.CclStatus]: CclStatusEnum.actionNeeded,
    })}`,
    [DashboardRecommendationTypeEnum.socialLinks]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.messengers]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.peculiarities]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: appRoute.myCompanies.path,

    [DashboardRecommendationTypeEnum.yandexNavigationStories]: `${appRoute.sources.path}?${objectToUrlParameters({
        [SourcesSearchParametersEnum.SourceIdList]: ProvidersIdsEnum.yandex,
    })}`,
    [DashboardRecommendationTypeEnum.yandexStories]: `${appRoute.sources.path}?${objectToUrlParameters({
        [SourcesSearchParametersEnum.SourceIdList]: ProvidersIdsEnum.yandex,
    })}`,

    [DashboardRecommendationTypeEnum.logo]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.cover]: appRoute.myCompanies.path,
    [DashboardRecommendationTypeEnum.products]: appRoute.myCompanies.path,

    [DashboardRecommendationTypeEnum.yandexPosts]: appRoute.postsManagement.path,
    [DashboardRecommendationTypeEnum.googlePosts]: appRoute.postsManagement.path,
};

export const recommendationLinkAnalyticsMap = {
    [DashboardRecommendationTypeEnum.check]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.review]: AnalyticsTarget.Dashboard.RecommendationReviews,
    [DashboardRecommendationTypeEnum.gallery]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.description]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.category]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.needAction]: AnalyticsTarget.Dashboard.RecommendationSources,
    [DashboardRecommendationTypeEnum.socialLinks]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.messengers]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.peculiarities]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.yandexCompetitorReviewsCount]:
        AnalyticsTarget.Dashboard.RecommendationReviewsGenerator,
    [DashboardRecommendationTypeEnum.yandexGoodPlace]: AnalyticsTarget.Dashboard.RecommendationCompanies,

    [DashboardRecommendationTypeEnum.yandexNavigationStories]: AnalyticsTarget.Dashboard.RecommendationSources,
    [DashboardRecommendationTypeEnum.yandexStories]: AnalyticsTarget.Dashboard.RecommendationSources,
    [DashboardRecommendationTypeEnum.logo]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.cover]: AnalyticsTarget.Dashboard.RecommendationCompanies,
    [DashboardRecommendationTypeEnum.products]: AnalyticsTarget.Dashboard.RecommendationCompanies,

    [DashboardRecommendationTypeEnum.yandexPosts]: AnalyticsTarget.Posts.Management,
    [DashboardRecommendationTypeEnum.googlePosts]: AnalyticsTarget.Posts.Management,
};
